import {
  titleUI,
  addressUI,
  addressSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['military-service-national-guard-unit-address-title']),
    unitAddress: addressUI({
      title: content['military-service-national-guard-unit-address-question'],
      omit: ['isMilitary', 'street3'],
    }),
  },
  schema: {
    type: 'object',
    required: ['unitAddress'],
    properties: {
      unitAddress: addressSchema({
        omit: ['isMilitary', 'street3'],
      }),
    },
  },
};
